module.exports = __webpack_public_path__ + "img/blog_post_preview.0915797.png";